/**
 * Per-page title and description, pulled from i18n so every locale gets its own.
 *
 * Only these two tags are set here on purpose: nuxt-seo-utils infers the
 * og:/twitter: equivalents from them, and emits canonical, og:url, og:type and
 * og:site_name on its own. `@nuxtjs/i18n`'s useLocaleHead() in app.vue adds the
 * hreflang alternates.
 *
 * Titles run through the `%s · %siteName` template set in nuxt.config.ts, so
 * pass the bare page name — "Booking", not "Booking · Katarraktis".
 */
export function usePageSeo(titleKey: string, descriptionKey: string) {
    const { t } = useI18n();

    useSeoMeta({
        title: () => t(titleKey),
        description: () => t(descriptionKey),
    });
}
